import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UISelect from 'UIComponents/input/UISelect';
import { getBlogs } from 'email-management-lib/EmailCreation/api/blogs';
import { useCallback, useMemo } from 'react';
import useGetCurrentBusinessUnit from 'messaging-management-lib/portal/hooks/useGetCurrentBusinessUnit';
import I18n from 'I18n';
import debounce from 'react-utils/debounce';
import useBlogRSSFeedDataState from '../../hooks/useBlogRssFeedDataState';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function HubspotBlogSelection() {
  const businessUnit = useGetCurrentBusinessUnit();
  const {
    blogID,
    setBlogID,
    frequency,
    setFrequency
  } = useBlogRSSFeedDataState();
  const onSelectBlog = useCallback(event => {
    setBlogID(event.target.value);
  }, [setBlogID]);
  const onSelectFrequency = useCallback(event => {
    setFrequency(event.target.value);
  }, [setFrequency]);
  const searchForBlogs = useMemo(() => debounce((input, callback) => {
    getBlogs({
      searchTerm: input,
      businessUnitId: businessUnit && businessUnit !== 'ALL' ? businessUnit : undefined
    }).then(response => {
      const options = response.objects.map(blog => ({
        text: `${blog.name} (${I18n.text(`SharedI18nStrings.languageNames.${blog.language}`)})`,
        value: blog.id
      }));
      callback(null, {
        options
      });
    }).catch(() => {
      callback(null, {
        options: []
      });
    });
  }, 200), [businessUnit]);

  // We can't use I18n.text at a global level, so we need to define the options here
  const FREQUENCY_SELECT_OPTIONS = ['instant', 'daily', 'weekly', 'monthly'].map(freq => ({
    text: I18n.text(`email-management-creation.createEmailPanel.blogRSS.hubspotBlog.frequencySelect.options.${freq}`),
    value: freq
  }));
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": "hubspot-blog-selection",
    children: [/*#__PURE__*/_jsx(UIFormControl, {
      required: true,
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "email-management-creation.createEmailPanel.blogRSS.hubspotBlog.title"
      }),
      children: /*#__PURE__*/_jsx(UISelect, {
        "data-test-id": "hubspot-blog-select",
        placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "email-management-creation.createEmailPanel.blogRSS.hubspotBlog.placeholder"
        }),
        value: blogID,
        filterOptions: false,
        loadOptions: searchForBlogs,
        onChange: onSelectBlog
      })
    }), blogID && /*#__PURE__*/_jsx(UIFormControl, {
      required: true,
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "email-management-creation.createEmailPanel.blogRSS.hubspotBlog.frequencySelect.title"
      }),
      children: /*#__PURE__*/_jsx(UISelect, {
        "data-test-id": "hubspot-blog-frequency-select",
        placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "email-management-creation.createEmailPanel.blogRSS.hubspotBlog.frequencySelect.placeholder"
        }),
        value: frequency,
        filterOptions: false,
        options: FREQUENCY_SELECT_OPTIONS,
        onChange: onSelectFrequency
      })
    })]
  });
}